import React from 'react';

import style from './activateUserModal.module.css';
import userStyle from '../userManagement.module.css';
import commonStyles from '../../../common/common.module.css';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';
import { TextField, Button } from '@material-ui/core';

interface DeactivateUserModalProps { 
  deactivateReason: string;
  modalOpen: boolean;
  handleChange: (e: any) => void;
  handleClose: () => void;
  deactivateUser: () => void;
};

const DeactivateUserModal = (props: DeactivateUserModalProps) => {

  return (
    <Dialog
      open={ props.modalOpen }
      onClose={ props.handleClose }
      aria-labelledby="form-dialog-title"
      maxWidth={ 'sm' }
      fullWidth={true}
    >
      <DialogTitle id="form-dialog-title" >
        <div className={ style.dialogTitle }>
          <span className={ style.name }>Deactivate user</span>
          <IconButton aria-label="Close" className={ style.close } onClick={ props.handleClose }>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div className={ `${ commonStyles.wrapper } ${ commonStyles.inputLabelWrapper } ` } >
          <label className={ commonStyles.inputLabel }>Deactivate user reason</label>
          <TextField
            id="reason"
            label=""
            name="deactivateUserReason"
            multiline
            fullWidth={true}
            rows={4}
            onChange={props.handleChange}
            value={props.deactivateReason}
            variant="outlined"
          />
        </div>
        <div className={ `${ userStyle.buttonContainer } ${ commonStyles.fSpaceBtw }` } >
          <Button
            color="primary"
            variant="contained"
            onClick={props.handleClose}
          >Close</Button>
          <Button
            color="primary"
            variant="contained"
            onClick={props.deactivateUser}
          >Deactivate user</Button>
        </div>
      </DialogContent>
    </Dialog>
  )
};

export default DeactivateUserModal;
